/**
 * AppShell — the running app: top bar + active surface + all overlays + toasts.
 * Mirrors the source's single-root render (surface flags + every modal sc-if).
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { colors } from '../theme';
import { useBridge } from '../store/bridgeStore';
import { Toasts } from '../components';
import TopBar from './TopBar';
import DirectoryScreen from '../screens/directory/DirectoryScreen';
import BuilderScreen from '../screens/builder/BuilderScreen';
import OpsScreen from '../screens/ops/OpsScreen';
import DetailModal from '../modals/DetailModal';
import ConnectModal from '../modals/ConnectModal';
import GrantDrawer from '../modals/GrantDrawer';
import ReplaceConfirm from '../modals/ReplaceConfirm';
import ApproveModal from '../modals/ApproveModal';
import LogsModal from '../modals/LogsModal';
import EditDetailsModal from '../modals/EditDetailsModal';
import ManageMcpModal from '../modals/ManageMcpModal';
import MapWithAiModal from '../modals/MapWithAiModal';
import IngestWizard from '../modals/IngestWizard';

export default function AppShell() {
  const { state } = useBridge();

  return (
    <View style={styles.root}>
      <TopBar />
      {state.directoryLoadError ? (
        <View style={styles.errorBanner}>
          <Text style={styles.errorText}>
            Failed to load live data from SK Bridge: {state.directoryLoadError}. The directory below is NOT live —
            fix the connection and reload.
          </Text>
        </View>
      ) : null}
      {state.surface === 'directory' ? <DirectoryScreen /> : state.surface === 'ops' ? <OpsScreen /> : <BuilderScreen />}

      {/* overlays */}
      <DetailModal />
      <ConnectModal />
      <GrantDrawer />
      <ReplaceConfirm />
      <ApproveModal />
      <LogsModal />
      <EditDetailsModal />
      <ManageMcpModal />
      <MapWithAiModal />
      <IngestWizard />

      <Toasts toasts={state.toasts} />
    </View>
  );
}

const styles = StyleSheet.create({
  root: { height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: colors.paper },
  errorBanner: { backgroundColor: '#b91c1c', paddingVertical: 10, paddingHorizontal: 16 },
  errorText: { color: '#ffffff', fontSize: 13, fontWeight: '600' },
});
